<label for="date">Date</label>
<div class="input-group mb-3">
    <ngb-datepicker id="date" [(ngModel)]="date" (ngModelChange)="update()" displayMonths="select" outsideDays="collapsed"></ngb-datepicker>
</div>
<label for="time">Time</label>
<div class="input-group mb-3">
    <ngb-timepicker id="time" [(ngModel)]="time" (ngModelChange)="update()" meridian="true"></ngb-timepicker>
</div>